import React from "react";
import Popover from "../../../../../../../../common-deprecated/components/popover/aem/Popover";
import { type BuildAndBuyLabelType, BnbLabel } from "../../../../../utils/labels";
import * as Button from "../../../../../../../../common-deprecated/styles/v2/toyota/components/Button";
import type { PriceType, FinanceOptionType } from "../../../../../../../../common-deprecated/types/CommonTypes";
import Price from "../../price/Price";
import Icon from "../../../../../../../../common-deprecated/styles/v2/toyota/globals/Icon";
import * as Type from "../../../../../../../../common-deprecated/styles/v2/toyota/globals/Type";
import { IconWrapper } from "../../../../../../../../common-deprecated/styles/v2/toyota/globals/IconWrapper";
import * as Styles from "../../../../../../../../common-deprecated/styles/v2/toyota/custom/basket/BasketList";
import { SrOnly } from "../../../../../../../../common-deprecated/styles/v2/toyota/utilities/ScreenreaderOnly";

type BasketItemRowType = {
    name: string;
    tooltip?: BuildAndBuyLabelType;
    price?: PriceType; // optional, return null if if we dont want to show a price
    priceFallback?: string; // show a string when price is 0, used to display "Standard" or nothing in some cases
    itemId?: string;
    financeOption?: FinanceOptionType;
    removeItem?: () => void;
};

const BasketItemRow = (props: BasketItemRowType): JSX.Element => {
    const { name, tooltip, price, priceFallback, itemId, removeItem, financeOption } = props;

    const hasPriceValue = price && (price.cash > 0 || price.discount > 0 || price.monthly > 0);
    const showSecondField = hasPriceValue || !!priceFallback || removeItem;

    return (
        <Styles.BasketListItem>
            <Styles.ListItemLabel>
                <Type.SmallText>{name}</Type.SmallText>
                {!!tooltip && (
                    <Popover showOnClick>
                        <BnbLabel label={tooltip} />
                    </Popover>
                )}
            </Styles.ListItemLabel>

            {showSecondField && (
                <Styles.ListItemValue hasPrice hasRemoveButton={!!removeItem}>
                    {hasPriceValue && price ? (
                        <Type.SmallHeading>
                            <Price price={price} financeItemId={itemId} financeOption={financeOption} />
                        </Type.SmallHeading>
                    ) : (
                        <Styles.PriceFallback>{priceFallback}</Styles.PriceFallback>
                    )}
                    {removeItem && (
                        <Styles.ActionWrapper>
                            <Button.Link
                                onClick={() => {
                                    removeItem();
                                }}
                            >
                                <SrOnly>
                                    <BnbLabel label="bnbA11yButtonRemoveFromBasket" />
                                </SrOnly>
                                <IconWrapper>
                                    <Icon variant="close" />
                                </IconWrapper>
                            </Button.Link>
                        </Styles.ActionWrapper>
                    )}
                </Styles.ListItemValue>
            )}
        </Styles.BasketListItem>
    );
};

export default BasketItemRow;
